import React from "react";
import { intl } from "LocaleWrapper";
import { FormGroup } from "@cofano/cck";
import { DataFormat, Fields, hasOptionalFieldPermission, Language } from "utils";
import { LocationLink } from "utils/LinkUtils";
import { LocationFromQuery } from "view/locations/LocationDetails";
import { useLocationFieldPermission } from "view/locations/utils/LocationUtils";
import { LocationType } from "__generated__/enums";
import { useStoreState } from "ezStore";

const LocationGeneralDetails = ({ location }: { location: LocationFromQuery | null  }) => {

	const session = useStoreState(store => store.session);

	const type = location?.type;

	const fieldPermission = useLocationFieldPermission(type ?? null);

	return (
		<React.Fragment>
			<FormGroup label={Language("DESCRIPTION")} labelPlacement="left-center" overflow="hidden">
				{location?.description || "-"}
			</FormGroup>

			<FormGroup label={Language("TYPE")} labelPlacement="left-center" overflow="hidden">
				{location?.type ? intl.formatMessage({ id: location.type }) : "-"}
			</FormGroup>

			<FormGroup
				label={Language("LOCATION_GROUP")}
				labelPlacement="left"
				labelPaddingTop={0}
				overflow="hidden">
				{location?.locationGroups && location.locationGroups.length > 0 ? location.locationGroups.map((item, index) => (
					<div key={index}>
						<LocationLink location={item} />
					</div>
				)) : "-"}
			</FormGroup>

			{hasOptionalFieldPermission(session, Fields.LOCATION, "externalId") && (
				<FormGroup label={Language("EXTERNAL_ID")} labelPlacement="left-center" overflow="hidden">
					{location?.externalId || "-"}
				</FormGroup>
			)}

			<FormGroup label={Language("CODE")} labelPlacement="left-center" overflow="hidden">
				{location?.code || "-"}
			</FormGroup>

			<FormGroup label={Language("ABBREVIATION")} labelPlacement="left-center" overflow="hidden">
				{location?.abbreviation || "-"}
			</FormGroup>

			<FormGroup label={Language("EMAIL")} labelPlacement="left-center" overflow="hidden">
				{location?.email || "-"}
			</FormGroup>

			<FormGroup label={Language("TELEPHONE")} labelPlacement="left-center" overflow="hidden">
				{location?.telephone || "-"}
			</FormGroup>

			{fieldPermission.hasPreHandlingTimeMinPermission && (
				<FormGroup label={Language("LOCATION_PRE_HANDLING_TIME_MIN")} labelPlacement="left-center" overflow="hidden">
					{DataFormat.minutes(location?.preHandlingTimeMin)}
				</FormGroup>
			)}

			{fieldPermission.hasPostHandlingTimeMinPermission && (
				<FormGroup label={Language("LOCATION_POST_HANDLING_TIME_MIN")} labelPlacement="left-center" overflow="hidden">
					{DataFormat.minutes(location?.postHandlingTimeMin)}
				</FormGroup>
			)}

			{fieldPermission.hasLoadingDepthPermission && (
				<FormGroup label={Language("LOCATION_LOADING_DEPTH")} labelPlacement="left-center" overflow="hidden">
					{DataFormat.meter(location?.loadingDepth)}
				</FormGroup>
			)}

			<FormGroup label={Language("COLOR")} labelPlacement="left-center" overflow="hidden">
				{DataFormat.color(location?.color)}
			</FormGroup>

			<FormGroup label={Language("ACTIVE")} labelPlacement="left-center" overflow="hidden">
				{DataFormat.boolean(location?.isActive)}
			</FormGroup>

			{hasOptionalFieldPermission(session, Fields.LOCATION, "erpLocation") && (
				<FormGroup label={Language("ERP_LOCATION")} labelPlacement="left-center" overflow="hidden">
					{DataFormat.boolean(location?.isErpLocation)}
				</FormGroup>
			)}

			{location?.type === LocationType.InlandTerminal && (
				<FormGroup label={Language("UAB_REGISTRATION")} labelPlacement="left-center" overflow="hidden">
					{location?.uabRegistration == true ? DataFormat.boolean(location?.uabRegistration) : "-"}
				</FormGroup>
			)}

			<FormGroup label={intl.formatMessage({ id: "LOCATION_NOTES" }) } labelPlacement="left-center" overflow="hidden">
				{location?.notes || "-"}
			</FormGroup>

			{fieldPermission.hasMaxShipLengthPermission && (
				<FormGroup label={intl.formatMessage({ id: "MAX_SHIP_LENGTH" }) } labelPlacement="left-center" overflow="hidden">
					{DataFormat.meter(location?.maxShipLength)}
				</FormGroup>
			)}

			{fieldPermission.hasMaxShipWidthPermission && (
				<FormGroup label={intl.formatMessage({ id: "MAX_SHIP_WIDTH" }) } labelPlacement="left-center" overflow="hidden">
					{DataFormat.meter(location?.maxShipWidth)}
				</FormGroup>
			)}

			{fieldPermission.hasMaxShipDraughtPermission && (
				<FormGroup label={intl.formatMessage({ id: "MAX_SHIP_DRAUGHT" }) } labelPlacement="left-center" overflow="hidden">
					{DataFormat.meter(location?.maxShipDraught)}
				</FormGroup>
			)}
		</React.Fragment>
	);
};

export default LocationGeneralDetails;
